import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
  selector: 'mx-component-lib-section',
  template: `
    <p class="text-title-large flex place-content-center mt-12 mb-4">{{ titleText }}</p>

    <!-- To apply the standard flex styling to a nested component, add "component-lib-content" to its host class property. -->
    <div class="
      flex flex-col items-center gap-y-8 mb-4
      [&>.component-lib-content]:flex
      [&>.component-lib-content]:flex-col
      [&>.component-lib-content]:items-center
      [&>.component-lib-content]:gap-y-8
    ">
      <ng-content/>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ComponentLibSectionComponent {

  @Input({required: true}) public titleText: string;
}
